import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actions as appActions } from "../../reducers/lab1/AppReducer";
import { actions as mainActions } from "../../reducers/MainReducer";
import AccessibilityImage from "../../assets/images/accessibility_icon.png";
import { Card, CardHeader, CardBody, Modal, Button } from "reactstrap";
import {
  changeTSize,
  setTextColor,
  setBackgroundColor,
} from "../footer/edit/editPage";
import SquircleButton from "../../assets/stylesheets/components/SquircleButton";

const mapStateToProps = (state) => {
  return {
    // General
    state: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ ...appActions, ...mainActions }, dispatch),
  };
};

const SiteAccessibilityButton = () => {
  const [open, setOpen] = useState(false);
  const [textPickerColor, setTextPickerColor] = useState("#345679");
  const [bgPickerColor, setBgPickerColor] = useState("#345679");
  const [isSmallView, setIsSmallView] = useState();

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setIsSmallView(false);
    } else {
      setIsSmallView(true);
    }
  }, []);

  const toggleCollapse = (e) => {
    e.preventDefault();
    if (e.target === e.currentTarget) {
      setOpen(!open);
    }
  };

  let state = {
    fontSize: 0,
    textColor: false,
    bgColor: false,
    displayColorPalette: false,
    backgroundColor: null,
    color: null,
  };

  function changeSize(size) {
    const state_size = state.fontSize;
    changeTSize(size);
    state = { ...state, fontSize: state_size + size };
  }

  function onTextColorChange(color) {
    setTextColor(color.hex);
    setTextPickerColor(color.hex);
  }

  function onBgColorChange(color) {
    setBackgroundColor(color.hex);
    setBgPickerColor(color.hex);
  }

  return (
    <div className="tw-flex tw-flex-row-reverse tw-items-end tw-gap-4 tw-fixed tw-bottom-0 tw-mb-6 tw-mr-6 tw-right-0 tw-z-50">
      <SquircleButton onClick={(e) => toggleCollapse(e)}>
        <img className="" src={AccessibilityImage} />
      </SquircleButton>
      {isSmallView ? (
        <Modal isOpen={open} size="sm">
          <Card
            className="tw-bg-white tw-flex-col tw-shadow-lg tw-shadow-labGray"
            outline
            color="light"
          >
            <CardHeader className="tw-bg-primary-blue">
              <h3 className="tw-title tw-text-xl tw-font-bold tw-text-white tw-text-center">
                Accessibility Tools
              </h3>
            </CardHeader>
            <CardBody className="tw-p-2">
              <p className="tw-text-left tw-body-text tw-px-3">
                Text Size Adjuster
              </p>
              <div className="tw-flex tw-flex-row tw-justify-evenly tw-gap-2 tw-my-2">
                <button
                  className="tw-bg-primary-blue tw-flex tw-justify-center tw-items-center tw-w-10 tw-aspect-square tw-border-none tw-rounded-full"
                  onClick={() => changeSize(1)}
                >
                  <p className="tw-text-white tw-title tw-leading-4 tw-text-center">
                    +
                  </p>
                </button>
                <button
                  className="tw-bg-primary-blue tw-flex tw-justify-center tw-items-center tw-w-10 tw-aspect-square tw-border-none tw-rounded-full"
                  onClick={() => changeSize(-1)}
                >
                  <p className="tw-text-white tw-title tw-leading-4 tw-text-center">
                    -
                  </p>
                </button>
              </div>
              <p className="tw-text-left tw-body-text tw-my-2 tw-px-3">
                Text Color Adjuster
              </p>
              <div className={"tw-w-full tw-flex tw-justify-center"}>
                <SketchPicker
                  disableAlpha
                  color={textPickerColor}
                  onChange={onTextColorChange}
                />
              </div>
              <p className="tw-text-left tw-body-text tw-my-2 tw-text-nowrap tw-px-3">
                Background Color Adjuster
              </p>
              <div className={"tw-w-full tw-flex tw-justify-center"}>
                <SketchPicker
                  disableAlpha
                  color={bgPickerColor}
                  onChange={onBgColorChange}
                />
              </div>
              <div className="tw-pt-2 tw-flex tw-flex-row-reverse tw-items-end tw-gap-4 tw-bottom-0 tw-mb-6 tw-mr-6 tw-right-0 tw-z-50">
                <Button
                  onClick={(e) => {
                    toggleCollapse(e);
                  }}
                >
                  Close
                </Button>
              </div>
            </CardBody>
          </Card>
        </Modal>
      ) : (
        <Modal
          isOpen={open}
          toggle={toggleCollapse}
          size="sm"
          className="tw-flex tw-items-start tw-justify-start tw-right-0 tw-absolute tw-pr-8"
        >
          <Card
            className="tw-bg-white tw-flex-col tw-shadow-lg tw-shadow-labGray"
            outline
            color="light"
          >
            <CardHeader className="tw-bg-primary-blue">
              <h3 className="tw-title tw-text-xl tw-font-bold tw-text-white tw-text-center">
                Accessibility Tools
              </h3>
            </CardHeader>
            <CardBody className="tw-p-2">
              <p className="tw-text-left tw-body-text tw-px-3">
                Text Size Adjuster
              </p>
              <div className="tw-flex tw-flex-row tw-justify-evenly tw-gap-2 tw-my-2">
                <button
                  className="tw-bg-primary-blue tw-flex tw-justify-center tw-items-center tw-w-10 tw-aspect-square tw-border-none tw-rounded-full"
                  onClick={() => changeSize(1)}
                >
                  <p className="tw-text-white tw-title tw-leading-4 tw-text-center">
                    +
                  </p>
                </button>
                <button
                  className="tw-bg-primary-blue tw-flex tw-justify-center tw-items-center tw-w-10 tw-aspect-square tw-border-none tw-rounded-full"
                  onClick={() => changeSize(-1)}
                >
                  <p className="tw-text-white tw-title tw-leading-4 tw-text-center">
                    -
                  </p>
                </button>
              </div>
              <p className="tw-text-left tw-body-text tw-my-2 tw-px-3">
                Text Color Adjuster
              </p>
              <div className={"tw-w-full tw-flex tw-justify-center"}>
                <SketchPicker
                  disableAlpha
                  color={textPickerColor}
                  onChange={onTextColorChange}
                />
              </div>
              <p className="tw-text-left tw-body-text tw-my-2 tw-text-nowrap tw-px-3">
                Background Color Adjuster
              </p>
              <div className={"tw-w-full tw-flex tw-justify-center"}>
                <SketchPicker
                  disableAlpha
                  color={bgPickerColor}
                  onChange={onBgColorChange}
                />
              </div>
            </CardBody>
          </Card>
        </Modal>
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SiteAccessibilityButton);
